import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

type Role = "therapist" | "webmaster" | "medic" | "parent" | "webmaster_medic";

interface ProtectedRouteProps {
  /** Poți da fie role (unic), fie roles (listă). Dacă le dai pe ambele, se folosește `roles`. */
  role?: Role;
  roles?: Role[];
  children: React.ReactNode;
}

const redirectForRole = (userRole: string | null) => {
  switch (userRole) {
    case "therapist":
      return "/therapist/dashboard";
    case "medic":
      return "/medic/dashboard";
    case "webmaster":
      return "/webmaster/dashboard";
    case "webmaster_medic":
      return "/webmaster-medic/appointments";
    case "parent":
      return "/parent/dashboard";
    default:
      return "/login";
  }
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ role, roles, children }) => {
  const { isAuthenticated, role: userRole } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" />;

  const allowed = Array.isArray(roles)
    ? roles.includes((userRole as Role) || "parent")
    : role
    ? userRole === role
    : false;

  if (!allowed) {
    return <Navigate to={redirectForRole(userRole)} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;